module.exports = __webpack_public_path__ + "img/pr-5.db8d854c.png";